import React, { useEffect, useState } from 'react';
import { Card, Spin, Alert, Button, message as antdMessage } from 'antd';
import { useSearchParams, useNavigate } from 'react-router-dom';
import wechatService from '../services/wechat';
import authService from '../services/auth';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'pending' | 'success' | 'error'>('pending');
  const [message, setMessage] = useState<string>('正在处理微信授权，请稍候...');
  const { setAuthData } = useAuth();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (!code || !state) {
      setStatus('error');
      setMessage('缺少必要的 code 或 state 参数');
      return;
    }

    const run = async () => {
      try {
        const res = await wechatService.completeCallback(code, state);
        if (res.success) {
          if (res.data?.access_token && res.data?.user) {
            authService.setToken(res.data.access_token);
            if (setAuthData) {
              setAuthData({ user: res.data.user, token: res.data.access_token, authenticated: true });
            }
            localStorage.setItem('auth_token', res.data.access_token);
            localStorage.setItem('user_info', JSON.stringify(res.data.user));
            setStatus('success');
            setMessage('扫码成功，已完成登录/绑定');
            antdMessage.success('微信登录成功');
            const redirectParam = searchParams.get('redirect');
            const isBindFlow = Boolean(res.data?.context?.bind_user_id);
            const target = redirectParam || (isBindFlow ? '/profile' : '/dashboard');
            navigate(target, { replace: true });
            return;
          }
          setStatus('success');
          setMessage('扫码成功，已通知系统完成登录/绑定，请回到原窗口查看');
        } else {
          setStatus('error');
          setMessage(res.message || '处理失败');
        }
      } catch (error: any) {
        setStatus('error');
        setMessage(error?.message || '处理失败，请重试');
      }
    };

    run();
  }, [searchParams]);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5', padding: 16 }}>
      <Card style={{ maxWidth: 420, width: '100%', textAlign: 'center' }}>
        {status === 'pending' && (
          <>
            <Spin size="large" />
            <div style={{ marginTop: 16 }}>{message}</div>
          </>
        )}
        {status === 'success' && (
          <Alert
            message="授权成功"
            description={message}
            type="success"
            showIcon
          />
        )}
        {status === 'error' && (
          <Alert
            message="授权失败"
            description={message}
            type="error"
            showIcon
          />
        )}

        <div style={{ marginTop: 16 }}>
          <Button type="primary" onClick={() => navigate('/login')}>
            返回登录
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default AuthCallback;
